import { Component, ChangeDetectionStrategy, input, computed, inject } from '@angular/core';
import { Location } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

export type PageHeaderIcon =
  | 'user'
  | 'user-data'
  | 'user-record'
  | 'tomass'
  | 'dialog'
  | 'movie'
  | 'gost'
  | 'staff'
  | 'contributor'
  | 'manual'
  | 'support'
  | 'dashboard'
  | 'download'
  | 'storage'
  | 'section'
  | 'admin'
  | 'section-group'
  | 'template';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatIconModule],
  host: {
    '[class]': 'hostClass()'
  }
})
export class PageHeaderComponent {
  private readonly location = inject(Location);

  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly icon = input<PageHeaderIcon>();

  /** バックリンクのラベル（例: "スタッフ"） */
  readonly backLabel = input<string>();

  /** バックリンクの前に表示するMaterial Icon名（例: "people_alt"） */
  readonly backIcon = input<string>();

  /** バックリンクのルート（例: ['/section-admin', sectionId, 'staff-list']） */
  readonly backRoute = input<string[]>();

  /** ブラウザ履歴で戻る（trueの場合、backRouteより優先） */
  readonly useHistoryBack = input<boolean>(false);

  protected readonly hostClass = computed(() => {
    const iconType = this.icon();
    return iconType ? `page-header--${iconType}` : '';
  });

  /** 戻るボタンを表示するか */
  protected readonly showBackButton = computed(() => {
    return this.backLabel() && (this.useHistoryBack() || this.backRoute());
  });

  /** ブラウザ履歴で戻る */
  protected goBack(): void {
    this.location.back();
  }
}
